import React from 'react';
import { ClockIcon, MapPinIcon } from 'lucide-react';
import { Container, Section } from '../ui/Section';
import { Reveal, stagger } from '../motion/Reveal';
import { DoodleHeart } from '../brand/Doodles';
import { DoodleScatter } from '../brand/DoodleScatter';
type Fact = {
  label: string;
  title: string;
  copy: string;
  icon: React.ReactNode;
  accent: string;
};
const facts: Fact[] = [{
  label: 'When',
  title: 'Thursday Nights',
  copy: 'Worship begins at 7:30 PM.',
  icon: <ClockIcon aria-hidden="true" className="h-8 w-8 text-brand-navy" strokeWidth={2.25} data-id="element-177" data-mp="2dcazgakhgqiz" />,
  accent: 'bg-brand-yellow'
}, {
  label: 'Who',
  title: 'Everyone Is Welcome',
  copy: 'Everyone is welcome, no matter your background or beliefs.',
  icon: <DoodleHeart className="h-9 w-9" color="var(--bcm-dark-blue)" data-id="element-178" data-mp="2nb0bvntm1iru" />,
  accent: 'bg-brand-pink'
}, {
  label: 'Where',
  title: 'UCF Student Union',
  copy: 'Find BCM on the third floor in Cape Florida Ballroom, Room 316.',
  icon: <MapPinIcon aria-hidden="true" className="h-8 w-8 text-brand-navy" strokeWidth={2.25} data-id="element-179" data-mp="3kk5e85fzkp84" />,
  accent: 'bg-brand-blue'
}];
export function QuickFacts() {
  return <Section className="relative overflow-hidden bg-[#fffdf6] py-16 sm:py-20" labelledBy="quick-facts-heading" data-id="element-180" data-mp="3oiunpmxwlmmh">
      <DoodleScatter tone="white" seed="quick-facts" data-id="element-181" data-mp="265zpk2yyrrh" />
      <Container className="relative" data-id="element-182" data-mp="27pdn415kqq3">
        <Reveal data-id="element-183" data-mp="758r41q10zgz">
          <h2 id="quick-facts-heading" className="font-serif text-3xl font-semibold leading-tight text-brand-navy sm:text-4xl" data-id="element-184" data-mp="73nxcebjdkk6">
            Your first visit, at a glance
          </h2>
        </Reveal>

        <ul className="mt-9 grid gap-5 sm:grid-cols-3" data-id="element-185" data-mp="g3azj2c3auea">
          {facts.map((fact, index) => <Reveal key={fact.label} as="li" delay={stagger(index)} className="relative flex h-full flex-col rounded-[20px] border-2 border-brand-navy bg-white p-6 transition-transform duration-200 hover:-translate-y-1" data-id="element-186" data-mp="l2e64r7px8od" data-mpi={index}>
              <span className={`absolute -top-3 left-6 rounded-full px-3 py-1 font-meta text-[11px] font-semibold uppercase tracking-[0.16em] text-brand-navy ${fact.accent}`} data-id="element-187" data-mp="3q711xlxsbgq2">
                {fact.label}
              </span>
              <div className="mt-3 flex h-9 items-center" data-id="element-188" data-mp="3u832q77co0u5">{fact.icon}</div>
              <h3 className="mt-4 font-display text-xl font-bold text-brand-navy sm:text-2xl" data-id="element-189" data-mp="d0917wfcgn0h">
                {fact.title}
              </h3>
              <p className="mt-2 font-sans text-[15px] leading-relaxed text-ink" data-id="element-190" data-mp="80cx7x6ncvkx">{fact.copy}</p>
            </Reveal>)}
        </ul>
      </Container>
    </Section>;
}